import { ConstructionCostRecordRow } from "../../types"

export function setLevel1Records(projectTypes: {value: number, label: string}[], projectTypeId: number): ConstructionCostRecordRow[] {
  const projectType = projectTypes.find(item => item.value === projectTypeId)
  return [
    { code: '1', category: projectType ? projectType.label : 'N/A', backgroundColor: '#f78f1f', useful_life: 50, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false }
  ]
}

export function setLevel2Records(): ConstructionCostRecordRow[] {
  return [
    { code: '1', category: 'Acquisition Costs', backgroundColor: '#77cbcc', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2', category: 'Construction Costs', backgroundColor: '#ced5eb', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
  ]
}

export function setLevel3Records(): ConstructionCostRecordRow[] {
  return [
    { code: '1', category: 'Acquisition Costs', backgroundColor: '#77cbcc', kind: 'header', isOpen: true, isHidden: false },
    { code: '1.01', category: 'Site acquisition', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '1.02', category: 'Administrative, finance, legal and marketing expenses', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2', category: 'Construction Costs', backgroundColor: '#ced5eb', kind: 'header', isOpen: true, isHidden: false },
    { code: '2.01', category: 'Demolition, site preparation and formation', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2.02', category: 'Substructure', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2.03', category: 'Structure', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2.04', category: 'Architectural works | non-structural works', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2.05', category: 'Services and equipment', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2.06', category: 'Surface and underground drainage', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2.07', category: 'External and ancillary works', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2.08', category: 'Preliminaries | Constructor\'s site overheads | general requirements', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2.09', category: 'Risk Allowances', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2.10', category: 'Taxes and Levies', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2.11', category: 'Work and utilities off-site', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2.12', category: 'Production and loose furniture, fittings and equipment', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
    { code: '2.13', category: 'Construction-related consultants and supervision', backgroundColor: '#e1d8d1', useful_life: 0, unit: null, periodValues: [{ value: 0, premium: null }], kind: 'value', isHidden: false },
  ]
}

export function setLevel4Records(): ConstructionCostRecordRow[] {
  const rows = [
    { code: '1', category: 'Acquisition Costs', backgroundColor: '#77cbcc', kind: 'header'},
    { code: '1.01', category: 'Site acquisition', backgroundColor: '#e1d8d1', kind: 'header'},
    { code: '1.01.010', category: 'Costs and premium required to procure site', backgroundColor: '#e3f2f4', kind: 'value',},
    { code: '1.01.020', category: 'Compensation to existing occupiers', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '1.01.030', category: 'Demolition, removal and modification of existing properties by way of payment to existing owners instead of carrying out physical work', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '1.01.040', category: 'Contributions for the preservation of heritage, culture and environment', backgroundColor: '#e3f2f4', kind: 'value' },
    { code: '1.01.050', category: 'Related fees to agents, lawyers, and the like', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '1.01.060', category: 'Related taxes and statutory charges', backgroundColor: '#e3f2f4', kind: 'value'},

    { code: '1.02', category: 'Administrative, finance, legal and marketing expenses', backgroundColor: '#e1d8d1', kind: 'header'},
    { code: '1.02.010', category: 'Client\'s general office overheads', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '1.02.020', category: 'Client\'s project-specific administrative expenses:', backgroundColor: '#e3f2f4', 
      tooltips: [
        'in-house project management and design team',
        'supporting project staff',
        'project office venue, furniture and equipment if not included in Constructor\'s preliminaries | site overheads',
        'stores and workshops',
        'safety and insurances',
        'staff training',
        'accommodation and travelling expenses for in-house team and external parties'
      ],
      kind: 'value'},
    { code: '1.02.030', category: 'Interest and finance costs', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '1.02.040', category: 'Legal expenses', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '1.02.050', category: 'Accounting expenses', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '1.02.060', category: 'Sales, leasing, marketing, advertising and promotional expenses', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '1.02.070', category: 'Taxes and statutory charges related to sales and lease', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '1.02.080', category: 'License and permit charges for operation and use', backgroundColor: '#e3f2f4', kind: 'value'},


    { code: '2', category: 'Construction Costs', backgroundColor: '#ced5eb', kind: 'header'},
    { code: '2.01', category: 'Demolition, site preparation and formation', backgroundColor: '#e1d8d1', kind: 'header'},
    { code: '2.01.010', category: 'Site survey and ground investigation', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.01.020', category: 'Environmental treatment', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.01.030', category: 'Sampling of hazardous or useful materials or conditions', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.01.040', category: 'Temporary fencing', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.01.050', category: 'Demolition of existing buildings and support to adjacent structures', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.01.060', category: 'Site surface clearance (clearing, grubbing, topsoil stripping, tree felling, minor earthwork, removal)', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.01.070', category: 'Tree transplant', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.01.080', category: 'Site formation and slope treatment', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.01.090', category: 'Temporary surface drainage and dewatering', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.01.100', category: 'Temporary protection, diversion and relocation of public utilities', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.01.110', category: 'Erosion control', backgroundColor: '#e3f2f4', kind: 'value'},

    { code: '2.02', category: 'Substructure', backgroundColor: '#e1d8d1', kind: 'header'},
    { code: '2.02.010', category: 'Foundation piling and underpinning', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'mobilisation and demobilisation',
        'trial piles and caisson',
        'permanent piles and caisson',
        'pile and caisson testing',
        'underpinning'
      ]
    },
    { code: '2.02.020', category: 'Foundations up to top of lowest floor slabs', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'excavation and disposal',
        'lateral supports',
        'raft footings, pile caps, column bases, wall footings, strap beams, tie beams',
        'substructure walls and columns',
        'lowest floor slabs and beams (excluding and beyond basement bottom slabs)',
        'lift pits',
        'composite or prefabricated work'
      ]
    },
    { code: '2.02.030', category: 'Basement sides and bottom', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'excavation and disposal',
        'lateral supports',
        'bottom slabs and blinding',
        'sides',
        'vertical waterproof tanking, drainage blanket, drains and skin wall',
        'horizontal waterproof tanking, drainage blanket, drains and topping slab',
        'insulation',
        'lift pits, sump pits, sleeves',
        'composite or prefabricated work'
      ]
    },

    { code: '2.03', category: 'Structure', backgroundColor: '#e1d8d1', kind: 'header'},
    { code: '2.03.010', category: 'Structural removal and alterations', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.03.020', category: 'Basement suspended floors (up to top of ground floor slabs)', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'structural walls and columns',
        'beams and slabs',
        'staircases'
      ]
    },
    { code: '2.03.030', category: 'Frames and slabs (above top of ground floor slabs)', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'structural walls and columns',
        'upper floor beams and slabs',
        'roof beams and slabs',
        'staircases',
        'fireproofing to steel structure'
      ]
    },
    { code: '2.03.040', category: 'Tanks, pools, sundries', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.03.050', category: 'Composite or prefabricated work', backgroundColor: '#e3f2f4', kind: 'value'},

    { code: '2.04', category: 'Architectural works | non-structural works', backgroundColor: '#e1d8d1', kind: 'header'},
    { code: '2.04.010', category: 'Non-structural removal and alterations', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.04.020', category: 'External elevations', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'non-structural external walls and features',
        'external wall finishes except cladding',
        'facade cladding and curtain walls',
        'external windows',
        'external doors',
        'external shop fronts',
        'roller shutters and fire shutters'
      ]
    },
    { code: '2.04.030', category: 'Roof finishes, skylights and landscaping (including waterproofing and insulation)', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'roof finishes',
        'skylights',
        'other roof features',
        'roof landscaping (hard and soft)'
      ]
    },
    { code: '2.04.040', category: 'Internal divisions', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'non-structural internal walls and partitions',
        'shop fronts',
        'toilet cubicles',
        'moveable partitions',
        'cold rooms',
        'internal doors',
        'internal windows',
        'roller shutters and fire shutters',
        'sundry concrete work'
      ]
    },
    { code: '2.04.050', category: 'Fittings and sundries', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'balustrades, railings and handrails',
        'staircases and catwalk not forming part of the structure, cat ladders',
        'cabinets, cupboards, shelves, counters, benches, notice boards, blackboards',
        'exit signs, directory signs',
        'window and door dressings',
        'decorative features',
        'interior landscaping',
        'access panels, fire service cabinets',
        'sundries'
      ]
    },
    { code: '2.04.060', category: 'Finishes under cover', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'floor finishes (internal and external)',
        'internal wall finishes and cladding',
        'ceiling finishes and false ceilings (internal or external)'
      ]
    },
    { code: '2.04.070', category: 'Builder\'s work in connection with services', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'plinth, bases',
        'fire-proofing enclosure',
        'hoisting beams, lift pit separation screens, lift shaft separator beams',
        'suspended manholes',
        'cable trenches, trench covers',
        'sleeves, openings and the like not allowed for in \'Fittings and sundries\''
      ]
    },
    { code: '2.04.080', category: 'Composite or prefabricated work', backgroundColor: '#e3f2f4', kind: 'value'},

    { code: '2.05', category: 'Services and equipment', backgroundColor: '#e1d8d1', kind: 'header'},
    { code: '2.05.010', category: 'Heating, ventilating and air-conditioning systems/air conditioners', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'seawater system',
        'cooling water system',
        'chilled water system',
        'heating water system',
        'steam and condensate system',
        'fuel oil system',
        'water treatment',
        'air handling and distribution system',
        'condensate drain system',
        'unitary air-conditioning system',
        'mechanical ventilation system',
        'kitchen ventilation system',
        'fume and smoke extraction system',
        'anaesthetic gas-extraction system',
        'window and split-type air conditioners',
        'air-curtains',
        'fans',
        'related electrical and control systems',
        'submissions, testing and commissioning'
      ]
    },
    { code: '2.05.020', category: 'Electrical services', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'high-voltage transformers and switchboards',
        'incoming mains, low-voltage transformers and switchboards',
        'mains and submains',
        'standby system',
        'lighting and power',
        'uninterruptible power supply',
        'electric underfloor heating',
        'local electrical heating units',
        'earthing/lightning protection and bonding',
        'submissions, testing and commissioning'
      ]
    },
    { code: '2.05.030', category: 'Fitting out lighting fittings', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.040', category: 'Extra low voltage electrical services', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'information and communications technology system',
        'staff paging/location',
        'public address system',
        'building automation',
        'security and alarm',
        'close circuit television',
        'communal aerial broadcast distribution and the like',
        'submissions, testing and commissioning'
      ]
    },
    { code: '2.05.050', category: 'Water supply and drainage above ground or inside basement', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'cold water supply',
        'hot water supply',
        'flushing water supply',
        'grey water supply',
        'cleansing water supply',
        'irrigation water supply',
        'rainwater disposal',
        'soil and waste disposal',
        'planter drainage disposal',
        'kitchen drainage disposal',
        'related electrical and control systems',
        'submissions, testing and commissioning'
      ]
    },
    { code: '2.05.060', category: 'Supply of sanitary fittings and fixtures (installation included in \'Water supply and above ground drainage\' unless not separable from costs of \'Fittings and sundries\')', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.070', category: 'Disposal systems', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'refuse',
        'laboratory waste',
        'industrial waste',
        'incinerator',
        'submissions, testing and commissioning'
      ]
    },
    { code: '2.05.080', category: 'Fire services', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'fire hydrant and hose reel system',
        'wet risers',
        'sprinkler system',
        'deluge system',
        'gaseous extinguishing system',
        'foam extinguishing system',
        'audio/visual advisory system',
        'automatic fire alarm and detection system',
        'portable hand-operated appliances and sundries',
        'related electrical and control systems',
        'submissions, testing and commissioning'
      ]
    },
    { code: '2.05.090', category: 'Gas services', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'coal gas',
        'natural gas',
        'liquid petroleum gas',
        'medical gas/laboratory gas',
        'industrial gas/compressed air/instrument air',
        'vacuum',
        'steam',
        'submissions, testing and commissioning'
      ]
    },
    { code: '2.05.100', category: 'Movement systems', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'lifts | elevators',
        'platform lifts',
        'escalators',
        'travellators | moving walkways',
        'conveyors',
        'submissions, testing and commissioning'
      ]
    },
    { code: '2.05.110', category: 'Gondolas', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.120', category: 'Turntables', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.130', category: 'Generators', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.140', category: 'Energy-saving features', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.150', category: 'Water and wastewater treatment equipment', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.160', category: 'Fountains, pools and filtration plant', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.170', category: 'Powered building signage', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.175', category: 'Audio/visual entertainment system', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.180', category: 'Kitchen equipment', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.190', category: 'Cold room equipment', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.200', category: 'Laboratory equipment', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.210', category: 'Medical equipment', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.220', category: 'Hotel equipment', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.230', category: 'Car park or entrances access control', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.240', category: 'Domestic appliances', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.250', category: 'Other specialist services', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.05.260', category: 'Builder\'s profit and attendance on services', backgroundColor: '#e3f2f4', kind: 'value'},

    { code: '2.06', category: 'Surface and underground drainage', backgroundColor: '#e1d8d1', kind: 'header'},
    { code: '2.06.010', category: 'Surface water drainage', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.06.020', category: 'Storm water drainage', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.06.030', category: 'Foul and wastewater drainage', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.06.040', category: 'Drainage disconnections and connections', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.06.050', category: 'CCTV inspection of existing or new drains', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.06.060', category: 'Buried Process Pipe', backgroundColor: '#e3f2f4', kind: 'value'},

    { code: '2.07', category: 'External and ancillary works', backgroundColor: '#e1d8d1', kind: 'header'},
    { code: '2.07.010', category: 'Permanent retaining structures', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.07.020', category: 'Site enclosures and divisions', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.07.030', category: 'Ancillary structures', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.07.040', category: 'Roads and paving', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.07.050', category: 'Landscaping (hard and soft)', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.07.060', category: 'Fittings and equipment', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.07.070', category: 'External services', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'water supply',
        'gas supply',
        'power supply',
        'communications supply',
        'external lighting',
        'utility disconnections and connections'
      ]
    },

    { code: '2.08', category: 'Preliminaries | Constructor\'s site overheads | general requirements', backgroundColor: '#e1d8d1', kind: 'header'},
    { code: '2.08.010', category: 'Construction management including site management staff and support labour', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.020', category: 'Temporary access roads and storage areas, traffic management and diversion (at the Constructors\' discretion)', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.030', category: 'Temporary site fencing and securities', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.040', category: 'Commonly shared construction plant', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.050', category: 'Commonly shared scaffolding', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.060', category: 'Other temporary facilities and services', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.070', category: 'Technology and communications: telephone, broadband, hardware, software', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.080', category: 'Constructor\'s submissions, reports and as-built documentation', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.090', category: 'Quality monitoring, recording and inspections', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.100', category: 'Safety, health and environmental management', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.110', category: 'Insurances, bonds, guarantees and warranties', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.120', category: 'Constructor\'s statutory fees and charges', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.130', category: 'Testing and commissioning', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.08.140', category: 'Extras for extreme climatic or working conditions (if priced separately according to local pricing practice)', backgroundColor: '#e3f2f4', kind: 'value'},

    { code: '2.09', category: 'Risk Allowances', backgroundColor: '#e1d8d1', kind: 'header' },
    { code: '2.09.010', category: 'Design development allowance', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.09.020', category: 'Construction contingencies', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.09.030', category: 'Price Level Adjustments', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'until tendering',
        'during construction'
      ]
    },
    { code: '2.09.040', category: 'Exchange rate fluctuation adjustments', backgroundColor: '#e3f2f4', kind: 'value'},

    { code: '2.10', category: 'Taxes and Levies', backgroundColor: '#e1d8d1', kind: 'header' },
    { code: '2.10.010', category: 'Paid by the Constructor', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.10.020', category: 'Paid by the Client in relation to the construction contract payments', backgroundColor: '#e3f2f4', kind: 'value'},

    { code: '2.11', category: 'Work and utilities off-site', backgroundColor: '#e1d8d1', kind: 'header' },
    { code: '2.11.010', category: 'Connections to, diversion of and capacity enhancement of public utility mains or sources off-site up to mains connections on-site', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'electricity',
        'transformers',
        'water',
        'sewer',
        'gas',
        'telecommunications'
      ]
    },
    { code: '2.11.020', category: 'Public access roads and footpaths', backgroundColor: '#e3f2f4', kind: 'value'},

    { code: '2.12', category: 'Production and loose furniture, fittings and equipment', backgroundColor: '#e1d8d1', kind: 'header' },
    { code: '2.12.010', category: 'Loose production, process and operating furniture, fittings and equipment not normally provided before completion of construction', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.12.020', category: 'Fixed production, process and operating furniture, fittings and equipment installed before completion of construction', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'production (including process and operating) equipment (including furniture and fittings)',
        'related instrument and control systems',
        'related safety and environmental control systems',
        'related storage and transfer systems',
        'services and equipment as described in Group 05 but dedicated to serve production equipment',
        'surface and underground drainage as described in Group 06 but dedicated to serve production equipment',
        'testing and commissioning',
        'licences and certifications to start production',
        'risks allowances',
        'taxes and levies'
      ]
    },

    { code: '2.13', category: 'Construction-related consultants and supervision', backgroundColor: '#e1d8d1', kind: 'header', isHidden: false },
    { code: '2.13.010', category: 'Consultants\' fees and reimbursable', backgroundColor: '#e3f2f4', kind: 'value',
      tooltips: [
        'architects (architectural, landscape, interior design, technical, etc.)',
        'engineers (geotechnical, civil, structural, mechanical, electrical and plumbing, technical, etc.)',
        'project managers',
        'surveyors (quantity surveying, land surveying, building surveying, cost engineering, etc.)',
        'specialist consultants (environmental, traffic, acoustic, facade, BIM, etc.)',
        'value management studies'
      ]
    },
    { code: '2.13.020', category: 'Charges and levies payable to statutory bodies or their appointed agencies (in connection with planning, design, tender and contract approvals, supervision and acceptance inspections)', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.13.030', category: 'Site supervision charges (including their accommodation and travels)', backgroundColor: '#e3f2f4', kind: 'value'},
    { code: '2.13.040', category: 'Payments to testing authorities or laboratories', backgroundColor: '#e3f2f4', kind: 'value'},
  ]
  const mappedRows = rows.map(row => {
    if (row.kind === 'header') {
      return {
        ...row,
        kind: 'header' as const,
        isOpen: true,
        isHidden: false
      }
    }
    return {
      ...row,
      kind: 'value' as const,
      useful_life: 0,
      unit: null,
      periodValues: [{value: 0, premium: null}],
      isHidden: false
    }
  })
  return mappedRows
}